import React from 'react';
import { Facebook, Twitter, Linkedin, Share2, Link as LinkIcon } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const SocialShare: React.FC = () => {
    const currentUrl = window.location.href;
    const title = document.title;
    const { toast } = useToast();

    const shareLinks = [
        {
            name: 'Facebook',
            icon: <Facebook className="w-5 h-5" />,
            url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
            color: 'hover:text-blue-600'
        },
        {
            name: 'Twitter',
            icon: <Twitter className="w-5 h-5" />,
            url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(title)}`,
            color: 'hover:text-sky-500'
        },
        {
            name: 'LinkedIn',
            icon: <Linkedin className="w-5 h-5" />,
            url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
            color: 'hover:text-blue-700'
        },
        {
            name: 'WhatsApp',
            icon: <Share2 className="w-5 h-5" />, // Using generic share icon looking like whatsapp forward
            url: `https://wa.me/?text=${encodeURIComponent(title + ' ' + currentUrl)}`,
            color: 'hover:text-green-500'
        }
    ];

    const handleShare = (url: string) => {
        window.open(url, '_blank', 'width=600,height=400');
    };

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(currentUrl);
            toast({
                title: "Lien copié !",
                description: "Le lien de la page a été copié dans le presse-papier.",
            });
        } catch (err) {
            console.error('Failed to copy: ', err);
            toast({
                title: "Erreur",
                description: "Impossible de copier le lien.",
                variant: "destructive"
            });
        }
    };

    return (
        <div className="mt-6 pt-6 border-t border-gray-800">
            <h5 className="text-sm font-semibold text-gray-300 mb-3">Partager cette page</h5>
            <div className="flex space-x-4">
                {shareLinks.map((link) => (
                    <button
                        key={link.name}
                        onClick={() => handleShare(link.url)}
                        className={`text-gray-400 transition-colors duration-200 ${link.color}`}
                        aria-label={`Partager sur ${link.name}`}
                        title={`Partager sur ${link.name}`}
                    >
                        {link.icon}
                    </button>
                ))}
                <button
                    onClick={handleCopyLink}
                    className="text-gray-400 transition-colors duration-200 hover:text-white"
                    aria-label="Copier le lien"
                    title="Copier le lien"
                >
                    <LinkIcon className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
};

export default SocialShare;
